import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParcelNumber = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	width: 29,
	height: 29,
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 5.5 L19.5 3.5 L20.5 19 L5.5 20.5 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinejoin: "round",
		strokeDasharray: "3 1.5"
	}), /* @__PURE__ */ _jsx("text", {
		x: 12,
		y: 15,
		textAnchor: "middle",
		fontSize: 7.5,
		fontWeight: "bold",
		fill: "currentColor",
		children: "\n      36\n    "
	})]
});
export default SvgParcelNumber;
